<template>
  <div :class="{'nav-active': IDE.layout.showNav}"
       id="ide">
    <div class="nav-panel">
      <course-groups
          v-if="IClassroom.course"
          :groups="IClassroom.course.groups"
          @change="groupChange"></course-groups>
    </div>

    <div v-if="IClassroom.group"
         class="classroom">
      <div class="classroom-header hero">
        <group-header
            :group="IClassroom.group"
            :course="IClassroom.course"
            @toggle-nav="toggleNav"></group-header>
      </div>

      <div class="classroom-body" ref="resize-columns">
        <web-classroom v-if="!IClassroom.group.done"></web-classroom>
        <course-group
            v-else
            :course="IClassroom.course"
            :group="IClassroom.group"></course-group>
      </div>
    </div>
    <div v-else class="classroom">
      <div class="classroom-header hero">

      </div>
      <div class="classroom-body" ref="resize-columns">
        <div class="classroom-container">
        </div>
      </div>
    </div>
    <simple-coding></simple-coding>

    <input-modal :ctrl="IDE.inputModal"></input-modal>
  </div>
</template>

<script>
import WebClassroom from '@/components/classroom/web/WebClassroom'
import CourseGroups from '@/components/classroom/web/CourseGroups'
import InputModal from '@/components/classroom/web/InputModal'
import '@/components/classroom/web/ide.styl'
import GroupHeader from '@/components/classroom/web/GroupHeader'
import IClassroom from '@/components/classroom/lib/IClassroom'
import CourseGroup from '@/components/classroom/web/CourseGroup'
import SimpleCoding from '@/components/classroom/simple_coding/SimpleCoding'

const IDE = window['IDE']

export default {
  components: {
    WebClassroom, CourseGroups, SimpleCoding,
    InputModal, GroupHeader, CourseGroup
  },
  data () {
    return {
      IDE,
      IClassroom,
      ui: {
        showNav: true
      }
    }
  },
  mounted () {
    IDE.registerIDE(this)
    IClassroom.registerClassroom(this)
  },
  methods: {
    groupChange (group) {
      IClassroom.enterGroup(group)
    },
    toggleNav () {
      IDE.layout = { showNav: !IDE.layout.showNav }
    }
  }
}
</script>

<style lang="stylus" scoped>
#ide {
  height 100vh
  width 100vw
  overflow hidden
  display flex
  background $neBg

  &.nav-active {
    .classroom {
      width calc(100% - 300px)
    }

    .nav-panel {
      width 300px
    }
  }

  .knowledge-map {
    position fixed
    left 0
    top 0
    height 100%
    width 100%
    background white
    overflow auto
    font-style italic
  }

  .nav-panel {
    width 0
    display inline-block
    height 100%
    overflow-x hidden
    overflow-y auto
    flex-shrink 0
    box-shadow $neShadow
    z-index 1
    transition width .3s
  }

  .classroom {
    height 100vh
    width 100%
    transition width .3s
  }
}

</style>
